import firebaseService from '@/services/firebase.service'
import $http from '@/services/http-common'

export default {
  state: {
    pdf: null,
    currentPageNum: 0,
    userPdfs: []
  },
  mutations: {
    setCurrentPageNum (state, payload) {
      state.currentPageNum = payload
    },
    setPdf (state, payload) {
      state.pdf = payload
    },
    setUserPdfs (state, payload) {
      state.userPdfs = payload
    }
  },
  actions: {
    async getUserPdfs ({ commit }) {
      commit('setLocalLoading', {
        active: true,
        componentId: 'userPdfsList'
      })
      const idToken = await firebaseService.getToken()
      const uid = await firebaseService.getUID()
      const { data } = await $http.get(`api/users/${uid}/pdfs`, {
        headers: {
          idToken
        }
      })
      commit('setUserPdfs', data.pdfs)
      commit('setLocalLoading', {
        active: false,
        componentId: 'userPdfsList'
      })
    },
    async loadPdf ({ commit }, payload) {
      commit('setLocalLoading', {
        active: true,
        componentId: 'uploadPdf'
      })
      const idToken = await firebaseService.getToken()
      const uid = await firebaseService.getUID()
      const { data } = await $http.get(`api/users/${uid}/pdfs/${payload.id}`, {
        headers: {
          idToken
        }
      })
      commit('setPdf', data.pdf)
      commit('setCurrentPageNum', data.currentPageNum)
      commit('setLocalLoading', {
        active: false,
        componentId: 'uploadPdf'
      })
    },
    resetPdf ({ commit }) {
      commit('setPdf', null)
    },
    async updatePdf ({ commit, state }, payload) {
      if (state.pdf) {
        if (!state.pdf.numPages) {
          const idToken = await firebaseService.getToken()
          await $http.put(`api/pdfs/${state.pdf.id}`, payload, {
            headers: {
              idToken
            }
          })
        }
      }
    },
    async updateUserPdf ({ commit, state }, payload) {
      const idToken = await firebaseService.getToken()
      const uid = await firebaseService.getUID()
      await $http.put(`api/users/${uid}/pdfs/${state.pdf.id}`, payload, {
        headers: {
          idToken
        }
      })
      commit('setCurrentPageNum', payload.currentPageNum)
    },
    async uploadPdf ({ commit }, payload) {
      try {
        commit('setLocalLoading', {
          active: true,
          componentId: 'uploadPdf'
        })
        commit('setError', null)
        if (payload.file) {
          const idToken = await firebaseService.getToken()
          const formData = new FormData()
          formData.append('pdf', payload.file, payload.file.name)
          const { data } = await $http.post('api/pdfs', formData, {
            headers: {
              idToken
            }
          })
          commit('setUser', data.user)
          commit('setPdf', data.pdf)
        } else {
          commit('setError', 'You need to upload a file first!')
        }
        commit('setLocalLoading', {
          active: false,
          componentId: 'uploadPdf'
        })
      } catch (error) {
        console.error(error)
        commit('setLocalLoading', {
          active: false,
          componentId: 'uploadEbook'
        })
      }
    }
  },
  getters: {
    getCurrentPageNum (state) {
      return state.currentPageNum
    },
    getPdf (state) {
      return state.pdf
    },
    getUserPdfs (state) {
      return state.userPdfs
    }
  }
}
